import { render, staticRenderFns } from "./TransactionBalancePage.vue?vue&type=template&id=43bdb619"
import script from "./TransactionBalancePage.vue?vue&type=script&lang=ts"
export * from "./TransactionBalancePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports